import {useQuery} from 'react-query';
import {getAdvertisementDetail, getRequirementDetail} from './index';

interface UseGetAdvertisementDetailProps {
  guid: string | undefined;
  advertisement_type: string | undefined;
  type?: string;
}

const useGetAdvertisementDetail = ({
  guid,
  advertisement_type,
  type,
}: UseGetAdvertisementDetailProps) => {
  const isEnabled = Boolean(guid);

  const {data, isLoading, refetch} = useQuery({
    queryKey: ['advertisement-detail', guid, advertisement_type, type],
    queryFn: () =>
      type === 'requirement'
        ? getRequirementDetail(guid as string, advertisement_type as string)
        : getAdvertisementDetail(guid as string, advertisement_type as string),
    enabled: isEnabled,
  });

  return {
    advertisementDetail: data,
    isLoading,
    refetch,
  };
};

export default useGetAdvertisementDetail;
